<template>
  <div style="display: inline-block">
    <el-button @click="updateOrderCostDialog = true">修改金额</el-button>
    <el-dialog title="修改金额" append-to-body :visible.sync="updateOrderCostDialog" width="30%">
      <el-form label-width="100px">
        <el-form-item label="修改金额">
          <el-input v-model="value"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateOrderCostDialog = false">取 消</el-button>
        <el-button @click="modifyCost">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postOrderId } from '@/api/order/order'

export default {
  name: "modifyCost",
  props: ['orderCost', 'orderId'],
  model: {
    prop: 'orderCost',
    event: 'change'
  },
  data() {
    return {
      updateOrderCostDialog: false,
      value: ''
    }
  },
  watch: {
    //监听视频的修改
    orderCost(val) {
      this.value = val
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      if (this.orderCost) {
        this.value = this.orderCost
      }
    },

    modifyCost() {
      const data = {
        cost: this.value
      }
      postOrderId(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.updateOrderCostDialog = false
          this.$message.success('修改成功');
          this.$emit('change', '')
        }else {
          this.updateOrderCostDialog = false
          this.$message.error('修改失败');
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
